import { render, staticRenderFns } from "./SnsReviewItems.vue?vue&type=template&id=93c396e0"
import script from "./SnsReviewItems.vue?vue&type=script&lang=js"
export * from "./SnsReviewItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports